import { useEffect } from 'react';
import { ESelectedLibraryItemType } from '../interfaces';
import FolderView from './folders/folder-view';
import { useParams } from 'react-router-dom';
import EmptyScreen from './empty-screen';
import AuthorView from './authors/author-view';
import LibrarySearchView from './search/search-view';
import { useLibraryStore } from '../data/library-store';

const LibraryHome = () => {

    const { path } = useParams();

    const selectedLibraryItem = useLibraryStore(store => store.selectedLibraryItem);
    const setSelectedLibraryItem = useLibraryStore(state => state.setSelectedLibraryItem);

    useEffect(() => {
        if(!path) return;

        const _path = path || '';

        if(_path === 'search') {
            setSelectedLibraryItem({
                type: ESelectedLibraryItemType.SEARCH,
                id: 0,
            });
            return;
        }

        if(_path.startsWith('f-')) {
            const folder_id = Number(_path.replace('f-', '')) || 0;
            if(!folder_id) return;

            setSelectedLibraryItem({
                type: ESelectedLibraryItemType.FOLDER,
                id: folder_id,
            });
            return;
        }

        if(_path.startsWith('a-')) {
            const author_id = Number(_path.replace('a-', '')) || 0;
            if(!author_id) return;

            setSelectedLibraryItem({
                type: ESelectedLibraryItemType.AUTHOR,
                id: author_id,
            });
        }

    }, [path, setSelectedLibraryItem]);

    return (
        <div className="flex flex-col flex-1 leading-7 h-screen relative z-50 bg-white w-screen">
            <div className="overflow-auto px-6 py-10 flex-1 flex flex-col">

                {
                    (!selectedLibraryItem || selectedLibraryItem?.type === ESelectedLibraryItemType.ROOT) &&
                    <EmptyScreen/>
                }

                {
                    selectedLibraryItem?.type === ESelectedLibraryItemType.FOLDER &&
                    <FolderView/>
                }

                {
                    selectedLibraryItem?.type === ESelectedLibraryItemType.AUTHOR &&
                    <AuthorView/>
                }

                {
                    selectedLibraryItem?.type === ESelectedLibraryItemType.SEARCH &&
                    <LibrarySearchView/>
                }
            </div>
        </div>
    )
};

export default LibraryHome;